<form *ngIf="group" [formGroup]="form">
  <div class="custom-question-box">
    <div class="radio__container__validation">
      <div class="radio__container">
        <div class="form-label">
          <p class="typog-body-large-bold">{{ group.radios.heading }}</p>
          <p *ngIf="group.radios.subheading">{{ group.radios.subheading }}</p>
        </div>
        <div class="radio-group">
          <ng-container *ngFor="let group of group.radios.radioGroup">
            <label>
              <input
                (change)="onSelectionChanged(group)"
                type="radio"
                [name]="control"
                [formControlName]="control"
                [value]="group.value"
              />
              {{ group.text }}
            </label>
          </ng-container>
        </div>
      </div>
      <div *ngIf="showValidation" class="validation__message">
        <dgx-components-icon
          name="circle-exclamation"
          size="sm"
        ></dgx-components-icon>
        Select an option to continue.
      </div>
    </div>

    <dgx-components-button
      type="submit"
      variant="primary"
      iconName="arrow-right"
      (click)="onSumbit(group)"
      data-automation="'ConfirmAD'"
    >
      Continue
    </dgx-components-button>
  </div>
</form>
